import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';

export const versicherungsnehmerJuristisch = function (
  state: boolean = false,
  action: AnyAction,
): boolean {
  switch (action.type) {
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      if (action.payload.versicherungsnehmer) {
        return action.payload.versicherungsnehmer.juristisch;
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};
